import {PropsWithChildren} from 'react'

import {
    BUTTON_DOUBLE_RATIO,
    BUTTON_PRIMARY_COLOR,
    BUTTON_VARIANT,
    CenterModalNotice,
    CenterModalConfirm,
} from '@defign/ui'

import {CustomModalProps} from '../interfaces'
import {ModalProvider} from '../modal/ModalProvider'

import {GlobalModalContext} from './context'
import {useCustomModalStore} from './useCustomModalStore'

function CustomModals({openedCustomModals}: {openedCustomModals: CustomModalProps[]}) {
    return (
        <>
            {openedCustomModals.map((modal, index) => {
                if (modal.type === 'ALERT') {
                    const onClose = modal.onClose
                    return (
                        <CenterModalNotice
                            key={index}
                            isOpen
                            content={{
                                title: modal.title,
                                description: modal.description,
                            }}
                            button={{
                                text: '확인',
                                onClick: onClose,
                                variant: BUTTON_VARIANT.TERTIARY,
                            }}
                            onClickDimmedLayer={onClose}
                        />
                    )
                } else if (modal.type === 'CONFIRM') {
                    const onCancelClick = modal.onCancelClick
                    const onConfirmClick = modal.onConfirmClick
                    return (
                        <CenterModalConfirm
                            key={index}
                            isOpen
                            content={{
                                title: modal.title,
                                description: modal.description,
                            }}
                            buttons={{
                                ratio: BUTTON_DOUBLE_RATIO.HALF,
                                leftButton: {
                                    text: '취소',
                                    variant: BUTTON_VARIANT.TERTIARY,
                                    onClick: onCancelClick,
                                },
                                rightButton: {
                                    text: '확인',
                                    color: BUTTON_PRIMARY_COLOR.NPAY_GREEN,
                                    variant: BUTTON_VARIANT.PRIMARY,
                                    onClick: onConfirmClick,
                                },
                            }}
                            onClickDimmedLayer={onCancelClick}
                        />
                    )
                }
                return null
            })}
        </>
    )
}

/** App Global 에 한번만 배치 */
export function GlobalProvider({children}: PropsWithChildren) {
    const {openedCustomModals, custom} = useCustomModalStore()

    return (
        <GlobalModalContext.Provider value={custom}>
            <ModalProvider>{children}</ModalProvider>
            <CustomModals openedCustomModals={openedCustomModals} />
        </GlobalModalContext.Provider>
    )
}
